import Widget from 'models/dashboard/widget'


Widget.TimeWidget = Widget.extend({});

export default Widget.TimeWidget;

